
import { Component } from '@theme/component';

class PdpPress extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.items = Array.from(this.querySelectorAll('.pdp-press__item'));
    this.logo = this.querySelector('.pdp-press__logo');
    this.name = this.querySelector('.pdp-press__name');
    this.quote = this.querySelector('.pdp-press__quote');
    if (!this.items.length) return;
    this.items.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
    this.select(this.items[0]);
  }

  select(btn) {
    this.items.forEach((b) => {
      const active = b === btn;
      b.classList.toggle('is-active', active);
      b.setAttribute('aria-current', active ? 'true' : 'false');
    });
    const logoSrc = btn.dataset.logo;
    if (this.logo) {
      if (logoSrc) {
        this.logo.srcset = logoSrc;
        this.logo.src = logoSrc;
        this.logo.alt = btn.textContent.trim();
      }
      this.logo.hidden = !logoSrc;
    }
    if (this.name) {
      this.name.hidden = !!logoSrc;
      if (!logoSrc) this.name.textContent = btn.textContent.trim();
    }
    if (this.quote) this.quote.textContent = btn.dataset.quote || '';
  }
}

if (!customElements.get('pdp-press-component')) customElements.define('pdp-press-component', PdpPress);
